interface MigrationConnector {
    connectorType: string
    connectorId?: string
    fromMarketplace?: boolean
    isReconnect?: boolean
    appCodeImmutable?: string
    channelId?: number | string
    isDraft?: boolean
    deleted?: boolean
}

interface MigrationProject {
    connectors?: MigrationConnector[]
}

export function isAltegioMarketplaceReconnect(project: MigrationProject): boolean {
    return Boolean(project?.connectors?.some(connector =>
        connector.connectorType === 'altegio' && connector.fromMarketplace === true && connector.isReconnect === true))
}

export async function prepareAltegioMarketplaceReconnect(
    project: MigrationProject,
    dependencies: {
        ensureBotConnector: () => Promise<void>
        ensureCascades: () => Promise<void>
    },
): Promise<{ step: 'channel-selection' | 'notifications' | 'complete'; channelId: number | string | null } | null> {
    if (!isAltegioMarketplaceReconnect(project)) return null
    const channel = project.connectors?.find(connector =>
        ['whatsappChannel', 'telegramChannel', 'maxChannel', 'maxBusiness'].includes(connector.connectorType) &&
        connector.channelId && !connector.isDraft && !connector.deleted)
    if (!channel) return { step: 'channel-selection', channelId: null }

    const bot = project.connectors?.find(connector => connector.connectorType === 'whatsappBasis' && !connector.deleted)
    await dependencies.ensureBotConnector()
    if (!bot?.appCodeImmutable) return { step: 'notifications', channelId: channel.channelId }

    await dependencies.ensureCascades()
    return { step: 'complete', channelId: channel.channelId }
}
